import { Injectable } from '@angular/core';
import { switchMap, map, share, catchError } from 'rxjs/operators';
import { Observable, of, EMPTY, Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { OperationsService } from '../operations/operations.service';
import { NotifierService } from 'angular-notifier';
import { ConfigService } from '../config/config.service';
// import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  public selectedCompanySource: Subject<number> = new Subject<number>();
  public selectedHeaderCompanySource: Subject<number> = new Subject<number>();

  constructor(private apiService: ApiService, private router: Router, private http: HttpClient,
     private notifierService: NotifierService, private operationsService: OperationsService,
     private configService: ConfigService) { }

  public updateCompanySelection(number){
    this.selectedCompanySource.next(number);
    console.log('Point 2');
  }

  public updateHeaderCompanySelection(number){
    this.selectedHeaderCompanySource.next(number);
  }

  public getSelectedCompanyMap(): Observable<number> {
    return this.selectedCompanySource.asObservable();
  }

  public getHeaderSelectedCompanyMap(): Observable<number> {
    return this.selectedHeaderCompanySource.asObservable();
  }

  getCompanies(partnerId?: string){
    partnerId = partnerId || localStorage.getItem('liquid_payout_portal_partnerId');
    const query = partnerId ? '?partnerId=' + partnerId : '';
    return this.apiService.get(`/company${query}`).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }

  getCompany(companyId: string){
    return this.apiService.get(`/company/${companyId}`).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }

  getCompanyAccounts(){
    return this.apiService.get(`/company/${localStorage.getItem('liquid_payout_portal_companyId')}/currencyBalance?partnerId=${localStorage.getItem('liquid_payout_portal_partnerId')}`).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }


  getCompanyLabelMapping(){
    return this.apiService.get(`/payout/instruction/mapping/${localStorage.getItem('liquid_payout_portal_companyId')}`).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }

  createCompany(companyForm){
    return this.apiService.post(`/company`, companyForm).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }

  deleteCompany(id){
    return this.apiService.delete(`/company/${id}`).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }

  updateCompany(id, companyForm){
    return this.apiService.update(`/company/${id}`, companyForm).pipe(switchMap((response: any) => {
      return of(response);
    }))
  }

  // getBankAccounts(companyId: string){
  //   return this.apiService.get(`/company/${companyId}/bankAccounts`).pipe(switchMap((response: any) => {
  //     return of(response);
  //   }))
  // }
}
